import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * Legacy org-level deep links (`/o/:orgSlug/org-settings`, `/o/:orgSlug/profile`,
 * and anything deeper) predate the 1/3/5-segment shim shapes. Redirect them to
 * the equivalent root-level leaf; React Router's route ranking keeps the more
 * specific `/o/...` shim routes winning.
 */
export const LegacyOrgShim = () => {
  const params = useParams();
  const location = useLocation();
  const splat = params['*'];
  return <Navigate to={splat ? `/${splat}${location.search}` : '/'} replace />;
};
